import * as svg from "../../../assets/connect-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const ConnectIcon = iconBuilder(svg, "ConnectIcon", "0 0 34 34");
